export { default } from './NothingFound'
